const products = [
  {
    title: "Asosiy Plyonka Turlari",
    desc: "Et magni et ea unde tempore. Corrupti quia adipisci qui dicta sint.",
    img: require("./images/product_6.png"),
  },
  {
    title: "Asosiy Zajim turlari",
    desc: "Et magni et ea unde tempore. Corrupti quia adipisci qui dicta sint.",
    img: require("./images/product_3.png"),
  },
  {
    title: "Tomchilab sug’orish tizimi",
    desc: "Et magni et ea unde tempore. Corrupti quia adipisci qui dicta sint.",
    img: require("./images/product_2.png"),
  },
  {
    title: "ISSIQXONANING sovutish TIZIMI",
    desc: "Et magni et ea unde tempore. Corrupti quia adipisci qui dicta sint.",
    img: require("./images/product_1.png"),
  },
  {
    title: "ISSIQXONANING ISITISH TIZIMI",
    desc: "Et magni et ea unde tempore. Corrupti quia adipisci qui dicta sint.",
    img: require("./images/product_4.png"),
  },
  {
    title: "QO’shimcha aksessuarlar",
    desc: "Et magni et ea unde tempore. Corrupti quia adipisci qui dicta sint.",
    img: require("./images/product_5.png"),
  },
];

export default products;
